export default class AbstractDialog {
  /**
   * @param {string} template css class of HtmlTemplate to clone
   * */
  constructor(template, callback = null) {
    this.dialog = document.querySelector(template)?.cloneNode(true);
    this.callback = callback;

    if (!this.dialog) {
      throw new Error("Dialog HTML template is missing or does not exist!");
    }

    this.activeClass = "is-shown";
    this.isShown = false;
  }

  init() {
    this.dialog.querySelector(".dialog-body")?.addEventListener("click", (e) => e.stopPropagation());
    this.initBtns();
    this.handleKeyboardEvents();
    this.handleClickEvents();
  }

  handleKeyboardEvents() {
    window.addEventListener("keydown", (e) => {
      if (!this.isShown) {
        return;
      }

      if (
        e.key === "Tab"
        || e.shiftKey && e.key === "Tab"
      ) {
        //e.preventDefault();
      }

      if (e.key === "Escape") {
        this.onDismiss(e);
      }
    });
  }

  handleClickEvents() {
    this.dialog.addEventListener("click", (e) => {
      if (!this.isShown) {
        return;
      }

      this.onDismiss(e);
    });

    this.dialog.querySelector(".dialog-body")?.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  /**
   * inits default confirm/dismiss buttons
   * */
  initBtns() {
    const btnConfirm = this.dialog.querySelector(".js-btn-confirm");
    const btnsDismiss = this.dialog.querySelectorAll(".js-btn-close");

    btnConfirm.addEventListener("click", this.onConfirm.bind(this));

    btnsDismiss?.forEach((btn) => {
      btn.addEventListener("click", this.onDismiss.bind(this));
    });
  }

  onConfirm(e) {
    e.preventDefault();

    this.hide();
    this.callback?.call(null, 1);
  }

  onDismiss(e) {
    e.preventDefault();

    this.hide();
    this.callback?.call(null, 0);
  }

  show() {
    if (this.isShown) {
      return;
    }

    document.body.appendChild(this.dialog);
    this.dialog.classList.add(this.activeClass);
    this.dialog?.setAttribute("tabindex", "0");
    this.dialog?.focus();

    this.isShown = true;
    sessionStorage.setItem("ignorekeyevs", this.isShown);
  }

  hide() {
    if (!this.isShown) {
      return;
    }

    // remove html
    this.dialog.remove();

    this.isShown = false;
    sessionStorage.setItem("ignorekeyevs", this.isShown);
  }
}
